export default __webpack_public_path__ + "static/G5_TotalIIDPS_GloballyRGB-9fd83bf2acd68525c29818721e3854b3.jpg";